import * as React from 'react';

class Footer extends React.Component {
  public render() {
    return (
        <footer>
          <a href="https://www.stellenanbieter.de/service/impressum/" target="_blank">Impressum</a>
          <a href="https://www.stellenanbieter.de/service/datenschutz/" target="_blank">Datenschutz</a>
          <a 
            href="https://www.stellenanbieter.de/service/allgemeine-geschaeftsbedingungen/" 
            target="_blank"
          >AGBs
          </a>
          <a href="https://www.stellenanbieter.de/service/kontakt/" target="_blank">Kontakt</a>
        </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.tsx